export default "__VITE_ASSET__DMJASLSR__"